import type { CartItems } from '../createCartItemsStore';

export const getCartItemsProductIds = (cartItems: CartItems) =>
	Object.keys(cartItems);
